import teacherImage from '../images/BF_Header_FuerLehrer.png';
import {Customization} from '@eduvision/toolkit';
import {default as CustomLoggedInUserView} from '../views/LoggedInUserView';

export const LoggedInUserView: Customization['LoggedInUserView'] = {
  component: CustomLoggedInUserView
  // headerImageSrc: teacherImage
};